var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.593,
    cy: 40.9632,
    r: 39.4807,
    fill: "white",
    stroke: "url(#paint0_linear_219_10254)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5931 39.4829H44.9707V50.4542C44.9707 53.6725 46.8798 56.7444 49.9637 58.2072L53.7819 59.9627L57.6001 58.2072C60.684 56.7444 62.5931 53.8187 62.5931 50.4542V39.4829Z",
    fill: "url(#paint1_linear_219_10254)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4301 54.6638H29.2979C23.4459 54.6638 18.593 49.8298 18.593 44.0005C18.593 38.7399 22.4468 34.4746 27.4424 33.4793C28.727 26.7969 34.579 21.9629 41.4301 21.9629C49.2803 21.9629 55.7033 28.3609 55.7033 36.1807H52.8486C52.8486 29.9249 47.7103 24.8065 41.4301 24.8065C35.5781 24.8065 30.7252 29.214 30.0116 34.9011V36.1807H28.727C24.5877 36.4651 21.4477 39.8773 21.4477 44.0005C21.4477 48.2658 25.0159 51.8203 29.2979 51.8203H41.4301V54.6638Z",
    fill: "url(#paint2_linear_219_10254)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_10254",
    x1: 40.593,
    y1: 0.982422,
    x2: 40.593,
    y2: 80.9439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_10254",
    x1: 53.7819,
    y1: 39.4829,
    x2: 53.7819,
    y2: 59.9627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_219_10254",
    x1: 37.1481,
    y1: 21.9629,
    x2: 37.1481,
    y2: 54.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.5102592823d724369e3b3d4a8d28808e.svg";
export { ForwardRef as ReactComponent };